/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Space, Image } from "antd";
import { Switch, FormControlLabel, Typography, TextField, InputAdornment, Box, Tab } from "@mui/material";
import clsx from 'clsx';
import customStyles from "../../../../../../assets/styles/customStyles";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { priceList } from "../../../../../../config/constant";
import { currencyFormat, idNamingConversion, capitalizeFirstLetter } from "../../../../../../helpers/utilities";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { VirtualKeyboard } from './VirtualKeyboard';
import { MixedPayments } from './MixedPayments';
import { getUploadedFile } from "../../../../../../helpers/utilities";


export const PaymentProcess = (props) => {
    const { form, changeHandler, mopDetails, customObject, error, headerView,
        handleActiveInputs, activeInputs, handleFormUpdate, businessDetails, parameterDetails
    } = props;

    const amountReceivedRef = useRef('');
    const nameRef = useRef('');
    let roundOffMethodRef = '';
    const roundOffAmount = useRef('');
    const discountAmount = useRef('');
    const classes = customStyles();

    const [value, setValue] = useState('payments');
    const [method, setMethod] = useState('');
    const [mixedPayments, setMixedPayments] = useState([
        { originalAmount: form?.invoiceAmount, amount: '', mopId: form?.mopId, mop: form?.mop }
    ]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setTimeout(() => {
            if (newValue === 'payments') {
                if (amountReceivedRef?.current)
                    amountReceivedRef.current.focus();
            } else {
                if (nameRef?.current)
                    nameRef.current.focus();
            }
        }, 250)
    };

    useEffect(() => {
        if (form?.salesType !== 'Sale Return') {
            if (form?.mixedPayment && mixedPayments && mixedPayments?.length > 0) {
                handleFormUpdate(mixedPayments);
            }
        }
    }, [mixedPayments]);


    useEffect(() => {
        console.log(form.mixedPayment, 'form.mixedPayment');
        if (form.mixedPayment && form?.type === 'view' && form?.mixedPayments) {
            const newTodos = form?.mixedPayments?.map((el, i) => {
                return { 'amount': el?.paymentAmount, 'mop': el?.mop };
            });
            setMixedPayments(newTodos);
        }
    }, [form.mixedPayment]);

    useEffect(() => {
        // if (mixedPayments && mixedPayments?.length > 0) {
        //     setMixedPayments([
        //         { originalAmount: form?.invoiceAmount, amount: '', mopId: form?.mopId, mop: form?.mop }
        //     ]);
        // }
    }, [form.invoiceAmount]);

    const deletePaymentMethod = (i) => {
        setMixedPayments([...mixedPayments.filter((el, e) => e !== i)]);
    }

    const handleAddPayment = () => {
        let amount = mixedPayments.reduce((a, v) => a = parseFloat(a) + parseFloat(v.amount), 0);
        setMixedPayments(oldPaymnets => [...oldPaymnets, { originalAmount: parseFloat(parseFloat(parseFloat(form?.invoiceAmount) - parseFloat(amount)).toFixed(2)), amount: parseFloat(parseFloat(parseFloat(form?.invoiceAmount) - parseFloat(amount)).toFixed(2)), mopId: form?.mopId, mop: form?.mop }]);
        setTimeout(() => {
            var objDiv = document.getElementById("paymentDiv");
            objDiv.scrollTo(0, objDiv.scrollHeight);
        });
    }

    const changeHandlerPayment = (e, name, index, relation = '') => {
        const newTodos = mixedPayments.map((el, i) => {
            if (index === i) {
                if (relation !== '') {
                    return { ...el, [name]: e.id, [relation]: e };
                } else {
                    return { ...el, [name]: e, };
                }
            }
            return el;
        });
        setMixedPayments(newTodos);
    }

    const handActivePaymentMethod = (index) => {
        setMethod(index)
    }

    const onKeyPress = (key) => {
        if (activeInputs === 'amount') {
            const newTodos = mixedPayments.map((el, i) => {
                if (i === method) {
                    let val = el[activeInputs] ? el[activeInputs] + '' + key : key;
                    return { ...el, [activeInputs]: val };
                }
                return el;
            });
            setMixedPayments(newTodos);
        } else {
            let val = form[activeInputs] ? form[activeInputs] + '' + key : key;
            changeHandler(val, activeInputs);
        }
    }

    const onKeyEnter = (key) => {

    }

    useEffect(() => {
        if (amountReceivedRef?.current)
            amountReceivedRef.current.focus();
    }, []);

    const handleClickButton = (v) => {
        if (v === 'amount') {
            if (amountReceivedRef?.current)
                amountReceivedRef.current.focus();
        } else if (v === 'round') {
            if (roundOffAmount?.current)
                roundOffAmount.current.focus();
        } else if (v === 'bill') {
            if (discountAmount?.current)
                discountAmount.current.focus();
        } else if (v === 'method') {
            if (roundOffMethodRef?.current)
                roundOffMethodRef.current.focus();
        }
    }

    return (
        <>
            <div className={clsx(classes.positionRelative)}>
                <div className={clsx(classes.top_right_ab, classes.customerLabelNone, { [classes.customDisabled]: form?.isReturnWithReceipt })}>
                    <Space direction="horizontal" align="center" size={[25, 25]}>
                        {
                            headerView ?
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.mop?.method || '---'}</Typography>
                                : <AutoCompleteComponent
                                    customLabel={"Select Method Of Payment"}
                                    heads={[{ 'key': 'method', 'name': 'Name' }]}
                                    details={parameterDetails?.mopIds && parameterDetails?.mopIds?.length > 0 ? mopDetails.filter(item => parameterDetails?.mopIds.includes(item.id)) : mopDetails}
                                    parentValue={customObject(mopDetails, form?.mopId)}
                                    position={"bottom"}
                                    variant={'outlined'}
                                    onChange={(data) => changeHandler(data, 'mopId')}
                                    parentError={error?.mopId}
                                />
                        }
                    </Space>
                </div>
                <TabContext value={value}>
                    <Box className={clsx(classes.tabDesign, { [classes.customDisabled]: form?.isReturnWithReceipt })}>
                        <TabList onChange={handleChange}>
                            <Tab className={classes.Bordertab_1} label="Payments" value={'payments'} />
                            <Tab className={classes.Bordertab_2} label="Party Details" value={'party-details'} />
                            {
                                businessDetails?.storeSalesQrCodeUri ? <Tab className={classes.Bordertab_2} label="QR Code" value={'qr-code'} /> : null
                            }
                        </TabList>
                    </Box>

                    <TabPanel value={"payments"}>
                        <Row gutter={20}>
                            {
                                form?.salesType === 'Sale' && <Col span={24} className={classes.textAlignRight}>
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, classes.marginRight10, 'MuiInputLabel-shrink')
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => changeHandler(!form?.mixedPayment, 'mixedPayment')}
                                            checked={form?.mixedPayment || false}
                                        />}
                                        label="Mixed Payment"
                                        labelPlacement="start"
                                        disabled={headerView}
                                        className={clsx(classes.marginLeft0, classes.marginBottom10)}
                                    />
                                </Col>
                            }
                            {
                                form?.mixedPayment ?
                                    <Col span={24}>
                                        <MixedPayments
                                            {...props}
                                            handleAddPayment={() => handleAddPayment()}
                                            changeHandlerPayment={(e, name, index, relation) => changeHandlerPayment(e, name, index, relation)}
                                            deletePaymentMethod={(i) => deletePaymentMethod(i)}
                                            handActivePaymentMethod={(i) => handActivePaymentMethod(i)}
                                            mixedPayments={mixedPayments}
                                            mopDetails={mopDetails}
                                            discountAmount={discountAmount}
                                            roundOffAmount={roundOffAmount}
                                            resetPayments={() => setMixedPayments([])}
                                            roundOffMethodRef={roundOffMethodRef}
                                        />
                                    </Col> : <>
                                        <Col span={8}>
                                            <div className={clsx(classes.priceDesignPayment, { [classes.customDisabled]: form?.isReturnWithReceipt })}>
                                                {
                                                    priceList[0].map((data, i) => (
                                                        <button key={i} onClick={() => { if (form?.salesType !== 'Sale Return') changeHandler(parseFloat(data), 'amountReceived') }}
                                                            className={clsx(classes.priceDesign, { [classes.disabled]: headerView })}>{`₹ ${data}`}</button>
                                                    ))
                                                }
                                            </div>
                                            <button onClick={() => changeHandler(parseFloat(parseFloat(form?.invoiceAmount).toFixed(2)), 'amountReceived')} className={clsx(classes.priceDesign, classes.priceDesignExact, { [classes.disabled]: headerView })}>
                                                Exact Amount
                                            </button>
                                        </Col>
                                        <Col span={16}>
                                            <Row className={clsx(classes.storeInvoiceAmountPayment)}>
                                                <Col span={24}>
                                                    <Row gutter={10}>
                                                        <Col span={12}>
                                                            <div className={clsx(classes.storeInvoiceAmount, classes.textAlignRight, classes.eqStoreHeight, classes.textAlignCenter)}>
                                                                <h4 className={classes.textAlignRight}>Total Amount Due</h4>
                                                                <p className={classes.textAlignRight}>{'₹ ' + currencyFormat(parseFloat(form?.invoiceAmount || 0))}</p>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className={clsx(classes.storeInvoiceAmount, classes.storeAmountReceived, classes.eqStoreHeight, classes.storeInvoiceRoundOffAmount, classes.textAlignRight,)}>
                                                                {
                                                                    headerView ? <>
                                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Round Off</Typography>
                                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                                            {capitalizeFirstLetter(form?.roundOffMethod || 'BLANK')} - ₹ {currencyFormat(form?.roundOffAmount || 0)}</Typography>
                                                                    </> : <Row>
                                                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                                            <h4>Round Off <span className={classes.shortKey}>(Alt + R)</span></h4>
                                                                        </Col>
                                                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={clsx(classes.removeUnderline)}>
                                                                            <AutoCompleteComponent
                                                                                name={[""]}
                                                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                                                details={[{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }]}
                                                                                parentValue={customObject([{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }], form?.roundOffMethod)}
                                                                                onChange={(data) => changeHandler(data?.id, 'roundOffMethod')}
                                                                                position={"bottom"}
                                                                                setRef={(ref) => { roundOffMethodRef = ref }}
                                                                                id={idNamingConversion('roundOffMethod', 'storeSales', 'DropDown')}
                                                                            />
                                                                        </Col>
                                                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                                                            <TextField autoComplete='one-time-code'
                                                                                label={[""]}
                                                                                fullWidth
                                                                                type="number"
                                                                                error={error?.roundOffAmount && true}
                                                                                helperText={error?.roundOffAmount}
                                                                                variant={'standard'}
                                                                                name="roundOffAmount"
                                                                                value={form.roundOffAmount}
                                                                                inputRef={roundOffAmount}
                                                                                InputProps={{
                                                                                    classes: {
                                                                                        input: clsx(classes.textFieldColor, classes.padding10L)
                                                                                    },
                                                                                }}
                                                                                inputProps={{
                                                                                    step: "any",
                                                                                }}
                                                                                id={idNamingConversion('roundOffAmount', 'storeSales', 'TextField')}
                                                                                onFocus={(e) => handleActiveInputs(e.target.name)}
                                                                                InputLabelProps={{
                                                                                    className: classes.textFieldLableColorCustom
                                                                                }}
                                                                                disabled={form?.roundOffMethod ? false : true}
                                                                                onChange={(e) => changeHandler(e)}
                                                                                className={clsx(classes.removeUnderline)}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row gutter={10}>
                                                        <Col span={12}>
                                                            <div className={clsx(classes.storeInvoiceAmount, classes.storeAmountReceived, classes.eqStoreHeight, classes.textAlignRight, classes.margin10t)}>
                                                                <h4>Bill Discount <span className={classes.shortKey}>(Alt + B)</span></h4>
                                                                {
                                                                    headerView ? <p>{'₹ ' + (currencyFormat(form?.discountAmount || 0))}</p> : <TextField autoComplete='one-time-code'
                                                                        className={clsx(classes.removeUnderline)}
                                                                        label={''}
                                                                        variant={'standard'}
                                                                        name={"discountAmount"}
                                                                        type={'number'}
                                                                        inputRef={discountAmount}
                                                                        value={form?.discountAmount || ''}
                                                                        fullWidth
                                                                        InputProps={{
                                                                            startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                                            classes: {
                                                                                input: clsx(classes.textFieldColor, classes.textAlignRight, classes.amountReceived)
                                                                            },
                                                                        }}
                                                                        id={idNamingConversion('Bill Discount', 'storeSales', 'TextField')}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        disabled={form?.salesType === 'Sale Return' ? true : false}
                                                                        InputLabelProps={{
                                                                            className: classes.textFieldLableColorCustom,
                                                                        }}
                                                                        onFocus={(e) => handleActiveInputs(e.target.name)}
                                                                        onChange={(e) => {
                                                                            if (form?.salesType !== 'Sale Return') {
                                                                                changeHandler(e.target.value, 'discountAmount')
                                                                            }
                                                                        }}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className={clsx(classes.storeInvoiceAmount, classes.storeAmountReceived, classes.eqStoreHeight, classes.textAlignRight, classes.margin10t)}>
                                                                <h4>Amount Received <span className={classes.shortKey}>(Alt + A)</span></h4>
                                                                {
                                                                    headerView ? <p>{'₹ ' + (currencyFormat(form?.amountReceived || (form?.salesType === 'Sale Return' ? form?.invoiceAmount : 0)))}</p> : <TextField autoComplete='one-time-code'
                                                                        className={clsx(classes.removeUnderline)}
                                                                        label={''}
                                                                        variant={'standard'}
                                                                        name={"amountReceived"}
                                                                        type={'number'}
                                                                        inputRef={amountReceivedRef}
                                                                        value={form?.amountReceived || (form?.salesType === 'Sale Return' ? parseFloat(form?.invoiceAmount || 0).toFixed(2) : '')}
                                                                        fullWidth
                                                                        InputProps={{
                                                                            startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                                            classes: {
                                                                                input: clsx(classes.textFieldColor, classes.textAlignRight, classes.amountReceived)
                                                                            },
                                                                        }}
                                                                        id={idNamingConversion('Amount Received', 'storeSales', 'TextField')}
                                                                        InputLabelProps={{
                                                                            className: classes.textFieldLableColorCustom,
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.keyCode === 40 || e.keyCode === 38) {
                                                                                e.preventDefault();
                                                                                return false
                                                                            }
                                                                        }}
                                                                        onFocus={(e) => handleActiveInputs(e.target.name)}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        disabled={form?.salesType === 'Sale Return' ? true : false}
                                                                        onChange={(e) => {
                                                                            if (form?.salesType !== 'Sale Return') {
                                                                                changeHandler(e)
                                                                            }
                                                                        }}
                                                                    />
                                                                }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <div className={clsx(classes.storeInvoiceAmount, classes.textAlignCenter, classes.eqStoreHeight, classes.margin10t)}>
                                                        <h4>Balance Due</h4>
                                                        <p>{'₹ ' + (form?.amountReceived ? currencyFormat(parseFloat(parseFloat(form?.invoiceAmount || 0).toFixed(2)) - parseFloat(parseFloat(form?.amountReceived || 0).toFixed(2))) : currencyFormat(0))}</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </>
                            }
                        </Row>
                    </TabPanel>
                    <TabPanel value={"party-details"}>
                        <Row gutter={40}>
                            <Col span={12}>
                                {
                                    headerView ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Name</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customerName || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.removeUnderline)}
                                            label={["Enter Name "]}
                                            name="customerName"
                                            variant={'standard'}
                                            value={form?.customerName}
                                            id={idNamingConversion('Customer Name', 'storeSales', 'TextField')}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                shrink: true
                                            }}
                                            inputRef={nameRef}
                                            onFocus={(e) => handleActiveInputs(e.target.name)}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: form?.customerName ? true : false
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col span={12}>
                                {
                                    headerView ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Phone Number</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customerMobile || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.removeUnderline)}
                                            label={["Enter Phone Number "]}
                                            //type="number"
                                            name={'customerMobile'}
                                            variant={'standard'}
                                            value={form?.customerMobile}
                                            id={idNamingConversion('Customer Mobile', 'storeSales', 'TextField')}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                shrink: form?.customerMobile ? true : false
                                            }}
                                            onFocus={(e) => handleActiveInputs(e.target.name)}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: form?.customerMobile ? true : false
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col span={12}>
                                {
                                    headerView ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Email</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.customerEmail || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin30t, classes.removeUnderline)}
                                            label={["Enter Email "]}
                                            variant={'standard'}
                                            name={"customerEmail"}
                                            value={form?.customerEmail}
                                            id={idNamingConversion('Customer Email', 'storeSales', 'TextField')}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                shrink: true
                                            }}
                                            onFocus={(e) => handleActiveInputs(e.target.name)}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: form?.customerEmail ? true : false
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                            <Col span={12}>
                                {
                                    headerView ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Comments</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.comment || '---'}</Typography>
                                    </> :
                                        <TextField autoComplete='one-time-code'
                                            className={clsx(classes.margin30t, classes.removeUnderline)}
                                            label={["Enter Comments "]}
                                            variant={'standard'}
                                            name={"comment"}
                                            id={idNamingConversion('Comments', 'storeSales', 'TextField')}
                                            value={form?.comment}
                                            fullWidth
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                shrink: form?.comment ? true : false
                                            }}
                                            onFocus={(e) => handleActiveInputs(e.target.name)}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: form?.comment ? true : false
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                }
                            </Col>
                        </Row>
                    </TabPanel>
                    {
                        businessDetails?.storeSalesQrCodeUri ?
                            <TabPanel value={"qr-code"}>
                                <Image src={getUploadedFile(businessDetails?.storeSalesQrCodeUri)} preview={false} />
                            </TabPanel> : null
                    }
                </TabContext>
                <VirtualKeyboard {...props}
                    value={value}
                    handleClickButton={(v) => handleClickButton(v)}
                    onKeyPress={(k) => onKeyPress(k)}
                    onKeyEnter={(k) => onKeyEnter(k)}
                />
            </div>
        </>
    )
}